import './micro.less'
import './micro_6.less'
import { npuEventStatistics } from '@/public/static/js/pages/utils/tracker_npu'
window.micro = new Vue({
    el: '#app',
    data() {
        this.docViewr = null
        return {
            courseInfo: baseInfo,
            bannerPlateType,
            prefix,
            baseUrl: baseUrl,
            avgStar: 0,
            courseId: baseInfo.contentId,
            userTab: '0',
            userTabMoblie: '0',
            fileGroups: baseInfo.fileGroups,
            filePreviewVisible: false,
            reviewFile: {},//预览文件
            collectionCount: baseInfo.collectionNumber,
            isCollect: false,
            commentData: {//评论列表信息
                page: 1,
                size: 12,
                total: 0,
                list: [],
                star: hasStar || 4.5,
                content: ''
            },
            knowledgeList: [],
            player: null,
            videoText: [],
            originVideoText: [],
            selectedLy: [],
            btnStyle: {},
            videoCurrentTime: 0,
            canDownload: baseInfo.entityData.is_attachment_ownload,
            noteLength: 0,//笔记条数
            timer: null,
            scrollTop: 0,
            learnIntervalTime: 0, // 当前学习时间，每{uploadInterval}清空一次
            uploadInterval: 60,
            unLoginShow,//未登录可进入页面
            showMiniScreen: true,
            videoId: '',//视频id
            hasLogin: false,
            showWatermark: baseInfo.entityData.showWatermark || false,
            playTimer: null,
            learnStatus: {},
            courseSetting: { ratio: 50 },
            isCompleted: false, // 学习是否完成
            canClick: true,
            coursePictureList: [],//课程tab页列表
            framerate: baseInfo.entityData.courseResources[0] ? baseInfo.entityData.courseResources[0].framerate : 25, //用户计算课件时间
            noteId: '',
            noteVideoTime: null,
            teacherInfo,
            videoList: [],
            currentPlayVideo: {},//当前播放视频
            currentPlayVideoId: '',
            recommendList: [],
            courseNumbers: {
                mooc: 0,
                micro: 0,
                spoc: 0,
            },
            headActive: bannerPlateType == 2 ? true : false,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            teacherAvatar: '',//教师头像
            commentCount: 0,
            hasCourseOverview: false,//本节概览是否有内容
            voiceTextShow: false,//语音文本是否显示
            hasKnowledgeEssentials: false,//显示知识要点tab
            knowledgePointInfo: {},//知识点发微课出入点信息等
            rightTabMaxHeight: 'unset',
            showKnowledgePoint: true,//是否显示知识点
            videoLink: resource_link.filter(el => el.type == 0),
            recourseLink: resource_link.filter(el => el.type == 1),
            ifShowResourceQa: false,//是否显示资源问答
            watermarkPictureUrl: '',//播放器版权水印图片
            watermarkLocation: 0,//播放器版权水印位置0-左上,1-左下,2-右上,3-右下
            alowDownload: true,
        }
    },
    computed: {
        showComment: function () {//是否显示课程评论
            return this.sysModulesFormat.includes('microcourse_comment_display')
        },
        ifNoteTab: function () {
            return this.userTab === '2'
        },
        videoHistoryParams: function () {
            return {
                id: '',
                courseId: baseInfo.contentId,
                videoId: this.currentPlayVideo.contentId
            }
        },
        notePanelInfo: function () {
            return {
                courseId: baseInfo.contentId,
                resourceId: this.currentPlayVideo.contentId,
                resourceName: this.currentPlayVideo.name,
                contentId: this.currentPlayVideo.contentId,
                courseName: baseInfo.name,
                courseType: baseInfo.entityData.courseType,
                note: "",
                noteType: "micro",
                pointOut: 0,
                remark: "",
                ready: !!this.currentPlayVideo.contentId,
            }
        },
        collectParam() {
            return {
                courseId: baseInfo.contentId,
                courseName: baseInfo.name,
                teachers: teacherInfo,
                collegeName: baseInfo.entityData.college.map((code, index) => {
                    return { code, value: baseInfo.entityData.collegeName ? baseInfo.entityData.collegeName[index] : '' }
                }),
                courseType: baseInfo.entityData.courseType == 0 ?
                    'micro' : baseInfo.entityData.courseType == 1 ?
                        'mooc' : baseInfo.entityData.courseType == 2 ?
                            'spoc' : '',
                courseCover: baseInfo.entityData.cover
            }
        },
        likeParam() {
            return {
                courseId: baseInfo.contentId,
                courseName: baseInfo.name,
                courseType: baseInfo.entityData.courseType
            }
        }
    },
    filters: {
        dateFormate(timeStamp) {
            return dateFormate(timeStamp, 'y/m/d h:m:s')
        }
    },
    mounted() {
        const that = this
        // 判断带笔记id否
        this.noteId = this.getQueryVariable('noteId')
        this.initDefaultTab()
        this.initExtendInfo()
        this.$on('ready', () => {
            //获取用户信息后执行
            this.initPermission()
            this.pageInit()
            //数据采集
            this.courseUserGather()
            //调一下微课学习接口
            this.reqStudy()
        })

        let shareUrl = location.origin + location.pathname
        //生成分享二维码
        new QRCode(document.getElementById("shareQrcode"), {
            text: shareUrl,
            width: 90,
            height: 90,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L, //纠错级别
        });
        //生成分享二维码
        new QRCode(document.getElementById("shareQrcodeMobile"), {
            text: shareUrl,
            width: 90,
            height: 90,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L, //纠错级别
        });
        //复制剪切板初始化
        var clipboard = new ClipboardJS(that.$refs.copy_link_btn, {
            text: () => '《' + baseInfo.name + '》\n' + shareUrl
        });
        var clipboardMobile = new ClipboardJS(that.$refs.copy_link_btn_mobile, {
            text: () => '《' + baseInfo.name + '》\n' + shareUrl
        });
        clipboard.on('success', function (e) {
            that.$message.success(that.$t('复制成功'))
            e.clearSelection();
        });
        clipboardMobile.on('success', function (e) {
            that.$message.success(that.$t('复制成功'))
            e.clearSelection();
        });
        //监听智能助手加载完成
        window.addEventListener('onLoadChatGpt', function () {
            window.setChatGptUrl({ course_id: baseInfo.contentId })
        })
        this.addHistory()
    },
    beforeDestroy() {
        window.removeEventListener('click', this.clearSelected);
        window.removeEventListener('scroll', (event) => this.scrollHandle(event, ".left"))


    },

    methods: {
        /**
         * @func getCourseSetting 获取课程的学习视频占比多少算结束
         * @func getLearnStatus 获取当前章节的学习状态
         * @func createLearnStatus 创建学习进度
         * @func competeCourseHandle 结束当前章节的课程
         * @func updateLearnTime 更新学习时间
         * @func playHandle 视频播放的回调
         * @func pauseHandle 视频暂停的回调
         * @func getCoursePictureList 获取课程截图列表
         */
        //  getCourseSetting() {
        //     API.reqCourseSetting({typeId: courseId}).then((res) => {
        //         if (res.message === "OK") {
        //             this.courseSetting = {...res.data};
        //             console.log('多少算结束',this.courseSetting)
        //         }
        //     });
        // },
        //微课学习
        reqStudy() {
            if (this.loginUserInfo && Object.keys(this.loginUserInfo).length) {
                API.reqMicroStudy({ courseId: this.courseId })
            }
        },
        //权限判断
        initPermission() {
            console.log('判断权限了')
            console.log(this.loginHref)
            //不校驗是否登錄了
            // if (!this.loginUserInfo && !this.unLoginShow && !(location.href.includes('x-cas-token') || localStorage.getItem('x-cas-token-app'))) {
            //     return location.href = this.loginHref
            // }
            if (this.loginUserInfo && Object.keys(this.loginUserInfo).length) {
                this.hasLogin = true
            }
            if (publishStatus != 1) {
                //课程未发布
                let hasCurrentTeacher = teachers.filter(code => code == this.loginUserInfo.user_code)
                // console.log('课程未发布',hasCurrentTeacher,this.loginUserInfo.user_code,teachers)
                if (!(this.loginUserInfo.user_code == 'sys' || this.loginUserInfo.user_code == 'zhiliao' || this.loginUserInfo.roles?.includes("r_course_manager") || this.loginUserInfo.roles?.includes("r_second_manager")) && !hasCurrentTeacher.length) {
                    // 且当前用户不是管理员且当前不是当前用户发布的课程
                    let href = '/learn/search'
                    if (sessionStorage.getItem('hideHead') && !this.getIfPc()) {
                        href = '/mobile/#/pages/course/index'
                    }
                    location.replace(href)
                }
            }
        },
        initDefaultTab() {
            if (this.noteId) {
                this.userTab = '3'
            } else if (this.videoList.length > 1) {
                this.userTab = '0'
            } else if (this.hasCourseOverview) {
                this.userTab = '1'
            } else if (this.sysModulesFormat.includes('courseware_screenshot_display') && this.coursePictureList.length) {
                this.userTab = '2'
            } else {
                this.userTab = '3'
            }
            console.log('default userTab', this.userTab)
        },
        getLearnStatus() {
            API.reqLearnStatus({ courseId: this.courseId }).then((res) => {
                if (res && res.message === config.successMessage) {
                    console.log('获取学习记录', res.data)
                    if (res.data) {
                        this.learnStatus = res.data;
                    } else {
                        this.createLearnStatus();
                    }
                }
            });
        },
        createLearnStatus() {
            console.log('【创建学习记录】')
            API.reqCreateOrUpdateLearnStatus({
                courseId: this.courseId,
                courseType: 0,
                status: 0,
                userCode: this.loginUserInfo.user_code,
                courseSemester: 1,

            }).then((res) => {
                if (res && res.message === "OK") {
                    this.learnStatus = res.data
                }
            });
        },
        competeCourseHandle() {
            API.reqCreateOrUpdateLearnStatus({
                id: this.learnStatus.id,
                courseType: 0,
                userCode: this.loginUserInfo.user_code,
                courseSemester: 1,
                status: 2,
            }).then((res) => {
                if (res.message === "OK") {
                    this.learnStatus.status = 2;
                }
            });
        },
        updateLearnTime() {
            // return
            API.reqUpdateLearnTime({
                courseId: this.courseId,
                timeInterval: parseInt(this.learnIntervalTime * 1000),
                courseType: baseInfo.entityData.courseType,
                resourceId: this.currentPlayVideo.contentId
            }).then((res) => {
                console.log(res)
                if (res.status === 200) {
                    console.log("【学习时长】：" + res.data.learnTime);
                }
            });
        },
        playHandle() {
            if (this.playTimer) clearInterval(this.playTimer)
            this.playTimer = setInterval(() => {
                this.learnIntervalTime++;
                // console.log('learnIntervalTime',this.learnIntervalTime)
                if (this.learnIntervalTime >= this.uploadInterval) {
                    this.updateLearnTime();
                    this.learnIntervalTime = 0;
                }
                const currentRate =
                    (this.player.currentTime / this.player.duration) *
                    100;
                const isEnd =
                    currentRate >= this.courseSetting.ratio ||
                    this.player.currentTime === this.player.duration;
                if (this.learnStatus.status !== 2 && isEnd) {
                    this.competeCourseHandle();
                }
            }, 1000);
        },
        pauseHandle() {
            clearInterval(this.playTimer);
            this.updateLearnTime();
            this.learnIntervalTime = 0;
        },
        getVideoList(arr) {
            return new Promise((resolve, reject) => {
                API.reqFileInfo(arr).then(res => {
                    if (res.status == 200) {
                        res = res.data.map((el, index) => {
                            return {
                                ...el,
                                contentId: arr[index]
                            }
                        })
                    } else {
                        res = res.data.map((el, index) => {
                            return {
                                ...el,
                                contentId: ''
                            }
                        })
                    }
                    resolve(res)
                }).catch(() => resolve([]))
            })
        },
        //更新或新增微课视频学习记录
        updateStudyTimes(data) {
            const { courseId, videoId, videoName } = data
            API.reqMicroStudyRecord({ courseId, videoId, videoName }).then(res => {
                console.log(res)
            })
        },
        async pageInit() {
            let that = this
            // debugger
            // 取消掉selection后的选中
            document.querySelector(".right .el-tabs__content").classList.add("noScroll");
            window.addEventListener('click', this.clearSelected);
            //课件列表滚动不弹浮窗
            window.addEventListener('scroll', (event) => this.scrollHandle(event, ".left"))
            //解决页面初始化activetab问题
            window.onload = function () {
                that.$forceUpdate()
            }
            const videoPathArr = await that.getVideoList(baseInfo.entityData.courseResources.map(el => {
                let contentId = el.contentId_ ? el.contentId_ : el.contentId
                if (!contentId) {
                    console.info('【无视频id】')
                }
                return contentId
            }))
            try {
                //知识点发微课信息
                let knowledgeResource = (baseInfo.entityData.knowledgeResources && baseInfo.entityData.knowledgeResources.length) ? baseInfo.entityData.knowledgeResources[0] : {}
                let tree = []
                if (baseInfo.entityData.course_chapter) {
                    // 栏目树
                    tree = JSON.parse(baseInfo.entityData.course_chapter)
                } else if (baseInfo.entityData.courseResources && baseInfo.entityData.courseResources.length) {
                    tree = baseInfo.entityData.courseResources
                }
                const findUrl = (arr, vArr) => {
                    return arr.map((v, index) => {
                        v.sort = index + 1
                        if (v.children && v.children.length) {
                            v.children = findUrl(v.children, vArr)
                        }
                        if (vArr.find(v2 => v2.contentId == v.contentId)) {
                            v.url = vArr.find(v2 => v2.contentId == v.contentId).filePath
                            v.isVideo = true
                        }
                        //通过知识点发微课的需要匹配那个视频是通过知识点发微课的
                        if (knowledgeResource.videoId == v.contentId) {
                            console.log('通过知识点发微课', knowledgeResource, v)
                            v.duration = knowledgeResource.outpoint - knowledgeResource.inpoint
                            v.knowledgeResource = knowledgeResource
                        }
                        return v
                    })
                }
                tree = findUrl(tree, videoPathArr || [])
                this.videoList = tree
                this.initDefaultTab()
            } catch (e) {
                console.error(e)
            }
            // if (baseInfo.entityData.courseResources.length) {
            //     //播放列表
            //     let arr = baseInfo.entityData.courseResources
            //     //知识点发微课信息
            //     let knowledgeResource = (baseInfo.entityData.knowledgeResources && baseInfo.entityData.knowledgeResources.length) ? baseInfo.entityData.knowledgeResources[0] : {}
            //     let videoList = arr.map((course, index) => {
            //         let name = course.name
            //         let url = videoPathArr[index] ? videoPathArr[index].filePath : ''
            //         let courseId = course.contentId_ ? course.contentId_ : course.contentId
            //         let duration = course.duration
            //         let sourceFrom = course.sourceFrom
            //         let data = {
            //             courseId,
            //             name,
            //             url,
            //             duration,
            //             index,
            //             sourceFrom
            //         }
            //         //通过知识点发微课的需要匹配那个视频是通过知识点发微课的
            //         if (knowledgeResource.videoId == course.contentId_) {
            //             console.log('通过知识点发微课', knowledgeResource)
            //             data.duration = knowledgeResource.outpoint - knowledgeResource.inpoint
            //             data.knowledgeResource = knowledgeResource
            //         }
            //         return data
            //     })
            //     this.videoList = videoList
            //     this.initDefaultTab()
            // }
            console.log('videoList', this.videoList)
            const findFirstVideo = (arr, indexs = []) => {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].isVideo) {
                        indexs.push(i);
                        return { node: arr[i], indexs: [...indexs] }; // 返回找到的节点和路径索引
                    } else if (arr[i].children && arr[i].children.length) {
                        let res = findFirstVideo(arr[i].children, [...indexs, i]); // 递归查找子节点，并传递当前路径索引
                        if (res) {
                            return res;
                        }
                    }
                }
                return null; // 如果没有找到视频节点，返回 null
            }
            let firstVideo = findFirstVideo(this.videoList)
            if (firstVideo) {
                console.error(firstVideo)
                this.handleVideoChange(firstVideo.node)
                // this.getCollectionCount()
                this.initCloseEvent()
                this.hasLogin && this.getLearnStatus();
            }
        },
        //获取教师课程数量
        getTeacherCourseNumbers(code) {
            API.reqteacherMoocList({ teacher: code, courseType: 1, isCreate: false, size: 1, pubish: 1 }).then(res => {
                if (res.status == 200 && res.data) {
                    this.courseNumbers.mooc = res.data.total
                }
            })
            API.reqteacherMoocList({ teacher: code, courseType: 2, isCreate: false, size: 1, pubish: 1 }).then(res => {
                if (res.status == 200 && res.data) {
                    this.courseNumbers.spoc = res.data.total
                }
            })
            API.reqteacherMicroList({ teacher: [code], courseType: 0, isCreate: false, size: 1, publishStatus: 1 }).then(res => {
                if (res.status == 200 && res.data) {
                    this.courseNumbers.micro = res.data.total
                }
            })
        },
        //获取教师信息，取头像
        getTeacherAvatar(teacherCode) {
            if (!teacherCode) return
            API.reqTeacherInfo({ teacherCode }).then(res => {
                if (res.status == 200) {
                    this.teacherAvatar = res.data.cover
                }
            })
        },
        //获取相关推荐列表
        getRecommendList(data) {
            API.reqRecommendAboutCourse(data).then(res => {
                if (res.status == 200) {
                    this.recommendList = res.data
                }
            })
        },
        scrollHandle(event, className) {
            const e = event || event.target;
            document.querySelector(className).classList.remove("noScroll");
            this.timer = setTimeout(() => {
                const stop = document.querySelector(className).scrollTop;
                if (stop == this.scrollTop) {
                    document.querySelector(className).classList.add("noScroll");
                }
            }, 300);
            if (className == '.left') {
                this.scrollTop = document.documentElement.scrollTop;
                if (this.scrollTop > 500 && this.showMiniScreen) {
                    if (!jQuery("#h5player").hasClass(".xgplayer-miniplayer-lay")) {
                        this.player && this.player.getMiniplayer();
                        jQuery(".xgplayer-miniplayer-lay").hide();
                        jQuery(".xgplayer-miniplayer-active").append("<div class='icon'>×</div>")
                        jQuery("#h5player .icon").click(() => {
                            this.player && this.player.exitMiniplayer()
                            jQuery("#h5player .icon").remove()
                            this.showMiniScreen = false
                        })
                    }
                } else {
                    this.player && this.player.exitMiniplayer()
                    jQuery("#h5player .icon").remove()
                    setTimeout(() => {
                        this.showMiniScreen = true
                    }, 200)
                }
            }
        },
        isdisabled(e) {
            let allarr = ['video', 'image', 'doc', 'audio', 'link'];
            if (e.fileType == 'link') return true
            let fileType = this.getFileType(e.filePath, false)
            // console.log(e.filePath,fileType,allarr.includes(fileType))
            if (allarr.includes(fileType)) {
                return true;
            } else {
                return false;
            }
        },
        async handleVideoChange(item) {
            if (item.type == 'column') {
                //栏目
                return
            } else if (item.type == 'hyperlink') {
                return window.open(item.link)
            }
            this.currentPlayVideo = { ...item }
            this.knowledgePointInfo = item.knowledgeResource || {}

            if (this.hasLogin) {
                const res = await API.reqLearnTotalDuration(this.courseId)
                if (res.status === 200) {
                    const totalDuration = Number(item.duration) / 10000
                    this.isCompleted = res.data >= totalDuration
                }
            }
            
            //先销毁可能存在的预览插件
            this.docViewr?.destroyEditor?.();
            this.docViewr = null
            this.player?.destroy?.()
            this.player = null
            this.audioPlaye?.destroy?.()
            this.audioPlaye = null

            //记录视频播放位置
            this.onPlayerStateChange()

            //获取语音文本开关
            await this.initVoiceTextPerssion(item.contentId)

            console.log('item', item)
            //兼容没有type的情况
            const suffix =  item.url.split('.').pop().toLowerCase()
            if(item.type == 'video' || item.type == 'clip' || suffix == 'mp4'){
                this.currentPlayVideo.type = 'video'
                this.$nextTick(() => {
                    this.playerInit(item)
                })
            } else if (item.type == 'picture' || suffix == 'jpg' || suffix == 'png' || suffix == 'gif'){
                this.currentPlayVideo.type = 'picture'
                this.$nextTick(() => {
                    this.picturePreviewInit(item)
                    this.hasCourseOverview = false
                    this.voiceTextShow = false
                })
            } else if (item.type == 'document' || suffix == 'doc' || suffix == 'docx' || suffix == 'xls' || suffix == 'xlsx' || suffix == 'ppt' || suffix == 'pptx' || suffix == 'pdf'){
                this.currentPlayVideo.type = 'document'
                this.$nextTick(() => {
                    this.docPreviewInit(item);
                    this.hasCourseOverview = false
                    this.voiceTextShow = false
                });
            } else if (item.type == 'audio' || suffix == 'mp3' || suffix == 'wav' || suffix == 'wma'){
                this.currentPlayVideo.type = 'audio'
                this.$nextTick(() => {
                    this.audioPlayerInit(item);
                });
            }
            if (window.hasLogin) this.updateStudyTimes({ courseId: this.courseId, videoId: item.contentId, videoName: item.name })
            this.getCoursePictureList(item)
            console.log('currentPlayVideo', this.currentPlayVideo)
            //西工大统计-课程资源点播学习
            npuEventStatistics({
                eventCode: 'view_courseResources',//事件code
                eventOpeartionObjectCatelogName: '微课',//操作对象所属分类名称
                eventOpeartionObjectCatelogCode: 'micro',//操作对象所属分类
                eventOpeartionObjectName: this.courseInfo.name,//操作对象名称
                eventOpeartionObjectCode: this.courseInfo.contentId,//操作对象code
                eventOpeartionObjectDetail: this.currentPlayVideo.name,//操作对象内容
            })

        },
        initVoiceTextPerssion(videoId) {
            if (!this.sysModulesFormat.includes('voicetext_check_display')) return this.voiceTextShow = true
            return new Promise((resolve) => {
                API.reqVoiceTextConfirm([videoId]).then(res => {
                    if (!res.status || !res.data || !res.data.length) return
                    let { textCheck = false } = res.data[0] || {}
                    this.voiceTextShow = textCheck
                }).finally(() => resolve())
            })
        },
        async getHistoryData(){
            return new Promise(async(resolve, reject) => {
                if (this.hasLogin) {
                    //获取记忆播放数据
                    try {
                        //获取记忆播放数据
                        await API.getVideoHistory(this.videoHistoryParams).then(async (res) => {
                            if (res.status == 200 && res.data) {
                                let lastPlayTime = 0
                                if (this.noteVideoTime != null) {
                                    //通过笔记信息记忆播放
                                    lastPlayTime = parseInt(this.noteVideoTime)
                                } else {
                                    lastPlayTime = parseInt(res.data.watchTime) / 10000000
                                }
                                //判断是否超出知识点播放范围，兼容老数据记录的记忆播放
                                if (option.customProgress) {
                                    if (lastPlayTime < (option.customProgress.inpoint / 10000000)) {
                                        lastPlayTime = (option.customProgress.inpoint / 10000000)
                                    } else if (lastPlayTime > (option.customProgress.outpoint / 10000000)) {
                                        lastPlayTime = (option.customProgress.outpoint / 10000000)
                                    }
                                }
                                resolve({
                                    id: res.data.id,
                                    lastPlayTime
                                })
                            } else if (!res.data) {
                                //没有记录新建记录
                                await API.saveVideoHistory(this.videoHistoryParams).then(res => {
                                    resolve({id: res.data.id})
                                }).catch(()=>{
                                    resolve({})
                                })
                            }
                        })
                    } catch {
                        resolve({})
                    }
                }else{
                    resolve({})
                }
            })
        },
        async playerInit(videoInfo) {
            let that = this
            let { url, knowledgeResource } = that.currentPlayVideo
            if (this.player) {
                this.player.off("play", this.playHandle);
                this.player.off("pause", this.pauseHandle);
                this.player.destroy();
            }
            var option = {
                id: 'h5player',
                url,
                fluid: true,//流式布局
                playsinline: true,
                miniplayerConfig: {
                    bottom: 20,
                    right: 0,
                    width: 320,
                    height: 180
                },
                textTrack: [],
                controlslist: "nodownload",
                // autoplay: true,
                videoInit: true,//初始化显示首帧
                screenShot: true,
                // pip: true, //打开画中画功能
                memoryPlay: this.hasLogin || false,//开启记忆播放
                videoHistoryParams: this.videoHistoryParams,
                lastPlayTimeHideDelay: 3, //提示文字展示时长（单位：秒）
                eventStatisticsParams: {//播放器行为统计参数
                    platform: (bannerPlateType == 3 || bannerPlateType == 4) ? 'aplus_queue' : '',//省平台为 aplus_queue，百度统计为 _hmt，设置了值即为开启
                    resource_name: baseInfo.name,
                    resource_id: baseInfo.contentId,
                    video_id: videoInfo.contentId,
                    video_name: (baseInfo.entityData.courseResources && baseInfo.entityData.courseResources.length) ? baseInfo.entityData.courseResources[0].name : '',
                    video_duration: baseInfo.entityData.videoDuration,
                },
                textTrackGrag: true,//开启字幕可拖拽
            }
            //判断是否允许倍数
            if (!baseInfo.entityData.allowed_double_speed || this.isCompleted) {
                option.playbackRate = [0.5, 0.75, 1, 1.5, 2]
            }
            //判断是否允许拖拽
            if (!(!baseInfo.entityData.allowed_drag || this.isCompleted)) {
                option.ignores = ['progress']
                option.keyShortcut = "off"
                this.canClick = false
            } else {
                this.canClick = true
            }
            //判断是否有知识点控制可播放范围
            // console.log(this.courseInfo.entityData.knowledgeResources && this.courseInfo.entityData.knowledgeResources.length)
            if (knowledgeResource && (knowledgeResource.inpoint || knowledgeResource.inpoint === 0) && (knowledgeResource.outpoint || knowledgeResource.outpoint === 0)) {
                //知识点发的微课隐藏右侧知识点
                this.showKnowledgePoint = false
                if (!baseInfo.entityData.allowed_drag) {
                    const { inpoint, outpoint } = knowledgeResource
                    option.customProgress = {
                        inpoint,
                        outpoint
                    }
                }
            }
            //获取记忆播放数据
            const {id,lastPlayTime} = await this.getHistoryData()
            if(id){
                option.videoHistoryParams = {
                    ...option.videoHistoryParams,
                    id,
                }
            }
            if(lastPlayTime){
                option.lastPlayTime = lastPlayTime
            }

            //通过组件方法获取语音文本
            let videoText = []
            if (this.voiceTextShow && this.sysModulesFormat.includes('micro_voice_show')) {
                await new Promise((resolve) => {
                    this.$nextTick(async () => {
                        if (this.getIfPc()) {
                            videoText = await this.$refs.voiceList.getVoiceText([videoInfo.contentId])
                        } else {
                            videoText = await this.$refs.voiceListMobile.getVoiceText([videoInfo.contentId])
                        }
                        resolve()
                    })
                })
            }

            //判断是否有翻译，有翻译可切换中英文
            if (videoText.length && this.sysModulesFormat.includes('micro_voice_show')) {
                option.textTrack.push({
                    // src: "/learn/static/test.vtt",
                    src: "/rman/v1/search/webvtt?contentId=" + videoInfo.contentId + "&voice=true&isSysAuth=true",
                    kind: "subtitles",
                    label: "简体中文",
                    srclang: "zh",
                    default: true
                })
                if (videoText[0].text_en) {
                    option.textTrack.push({
                        // src: "/learn/static/test.vtt",
                        src: "/rman/v1/search/webvtt?contentId=" + videoInfo.contentId + "&voice=true&lang=en&isSysAuth=true",
                        kind: "subtitles",
                        label: "英语",
                        srclang: "en",
                        default: false
                    })
                }
            }
            //延迟100ms，不然初始化会报错
            await new Promise((res) => {
                setTimeout(() => {
                    res()
                }, 100);
            })
            console.log('初始化参数', option)
            if (url && url.split('?')[0].includes('.flv')) {
                that.player = new FlvJsPlayer(option);
            } else if (url && url.split('?')[0].includes('.m3u8')) {
                that.player = new HlsJsPlayer(option);
            } else {
                that.player = new Player(option);
            }
            // console.log(this.player)
            this.hasLogin && this.player.on("play", this.playHandle);
            this.hasLogin && this.player.on("pause", this.pauseHandle);
            this.player.on('timeupdate', e => {
                this.videoCurrentTime = (e.video.currentTime || 0) * VIDEOTIMEUNIT
            })
            this.watermarkInit(option.id, this.player)
            this.player.on('ended', function () {
                that.canClick = true
            })
            this.getRightTabMaxHeight()
        },
        picturePreviewInit(item) {
            // console.log("预览图片", el);
            this.$nextTick(() => {
                this.getRightTabMaxHeight()
            })
        },
        //音频初始化
        async audioPlayerInit(item) {
            await new Promise((res) => {
                //需要等待dom渲染完成
                setTimeout(() => {
                    res()
                }, 800);
            })
            if (this.audioPlayer) {
                this.audioPlayer.off("play", this.playHandle);
                this.audioPlayer.off("pause", this.pauseHandle);
                this.audioPlayer.destroy();
                this.audioPlayer = null;
            }
            var option = {
                id: "music_player",
                url: [
                    {
                        src: item.url,
                        name: item.name,
                        poster: "",
                    },
                ],
                memoryPlay: this.hasLogin || false,//开启记忆播放
                videoHistoryParams: this.videoHistoryParams,//播放历史获取参数
            };
            this.$nextTick(async () => {
                //获取记忆播放数据
                const {id,lastPlayTime} = await this.getHistoryData()
                if(id){
                    option.videoHistoryParams = {
                        ...option.videoHistoryParams,
                        id,
                    }
                }
                if(lastPlayTime){
                    option.lastPlayTime = lastPlayTime
                }
                console.log('初始化参数', option)
                console.error(document.getElementById('music_player'))
                this.audioPlayer = new Music(option);
                this.hasLogin && this.audioPlayer.on("play", this.playHandle);
                this.hasLogin && this.audioPlayer.on("pause", this.pauseHandle);
                this.watermarkInit(option.id, this.player)
            })
            this.$nextTick(() => {
                this.getRightTabMaxHeight()
            })
        },
        docPreviewInit(item) {
            const that = this;
            const filepath = item.url;
            const filename = decodeURIComponent(common.getFileNameByPath(filepath));
            const fileType = common.getFileTypeByPath(filepath);
            console.log('fileType', fileType)
            if (fileType == 'pdf' && (this.bannerPlateType == 6 ? this.getIfPc() : true)) {
                this.currentPlayVideo.docType = 'pdf'
            }
            const key = Date.now().toString();
            const documentType = common.getDocumentType(fileType);
            const url = filepath.includes("http") ? filepath : location.origin + filepath;
            const config = {
                document: {
                    fileType,
                    key,
                    title: filename,
                    url,
                    permissions: {
                        print: that.alowDownload,
                        download: that.alowDownload
                    }
                },
                documentType,
                height: "100%",
                type: that.getIfPc() ? "desktop" : 'mobile',//desktop mobile embedded
                width: "100%",
                lang: "zh-cn",
                editorConfig: {
                    // "coEditing": {
                    //     "mode": "fast",
                    //     "change": true
                    // },
                    lang: "zh-cn",
                    region: "zh-CN",
                    location: "cn",
                    mode: that.getIfPc() ? "view" : 'mobile',//view edit
                    user: {
                        // "group": "Group1",
                        id: this.loginUserInfo ? this.loginUserInfo.user_code : 'youke',
                        name: this.loginUserInfo ? this.loginUserInfo.nick_name : '游客'
                    },
                    // "plugins": {},
                    customization: {
                        help: false,
                        hideNotes: true,
                        comments: true,
                        chat: false,
                        integrationMode: "embed",
                        logo: {
                            image: "/documentserver/web-apps/apps/common/main/resources/img/header/header-logo_s.png",
                            imageDark: "/documentserver/web-apps/apps/common/main/resources/img/header/dark-logo_s.png",
                            url: "http://www.sobey.com"
                        },
                        uiTheme: "theme-classic-light",//theme-light, theme-classic-light, theme-dark, theme-contrast-dark default-dark, default-light default:theme-classic-light
                        forcesave: that.alowDownload,
                        zoom: -1, //初始化自适应缩放
                        autosave: false,
                    }
                },
            }
            if (that.alowDownload) {
                config.document.permissions = {
                    print: true,
                    download: true,
                }
            }
            config.token = common.jwtSign(config, "tUVvbKk2mX4T40MBRrtj");
            console.log(config)
            this.$nextTick(() => {
                const dom = document.createElement('div')
                dom.setAttribute('id', 'document-container')
                document.querySelector('.preview_box.document').appendChild(dom)
                setTimeout(() => {
                    that.docViewr = new DocsAPI.DocEditor("document-container", config);
                    that.getRightTabMaxHeight()
                }, 2000)
            })
        },
        //视频水印
        watermarkInit(id, player) {
            let that = this
            if (!that.showWatermark && !that.sysModulesFormat.includes('player_all_show_watermark')) return
            if (this.loginUserInfo && this.loginUserInfo.nick_name && this.loginUserInfo.user_code) {
                let parentDom = document.querySelector('#' + id)?.parentNode
                const watermark_density = (this.sysModules.find(item => item.code == 'course_watermark_density') || {}).value || 5
                parentDom && watermark.load({
                    watermark_color: '#eee',
                    watermark_rows: (watermark_density ?? 5) / 5 * (that.getIfPc() ? 4 : 2),
                    watermark_cols: (watermark_density ?? 5) / 5 * (that.getIfPc() ? 3 : 2),
                    watermark_width: parentDom.clientWidth / 8,                //水印宽度
                    watermark_height: parentDom.clientHeight / 6,               //水印长度
                    watermark_parent_node: document.getElementById(id),
                    watermark_txt: `${that.loginUserInfo.nick_name}，${that.loginUserInfo.user_code}`,
                    watermark_alpha: 0.35,
                    watermark_fontsize: parentDom.clientWidth / 1200 * 18 + 'px'
                })
            }
            if (player) {
                player.on('requestFullscreen', () => {
                    that.watermarkInit(id)
                })
                player.on('exitFullscreen', () => {
                    that.watermarkInit(id)
                })
            }
        },
        //下载参考资料
        fileDownload(file) {
            console.log(file)
            if (!file) return
            var a = document.createElement("a");
            a.download = file.extraData + '.' + file.filePath.split('.').pop();
            a.href = file.filePath;
            a.rel = 'noopener noreferrer';
            jQuery("body").append(a); // 修复firefox中无法触发click
            a.click();
            jQuery(a).remove();
            //西工大统计-课程资源下载
            npuEventStatistics({
                eventCode: 'download_courseResources',
                eventOpeartionObjectCatelogName: '微课',//操作对象所属分类名称
                eventOpeartionObjectCatelogCode: 'micro',//操作对象所属分类
                eventOpeartionObjectName: this.courseInfo.name,//操作对象名称
                eventOpeartionObjectCode: this.courseInfo.contentId,//操作对象code
                eventOpeartionObjectDetail: file.filePath.split('/').pop(),//操作对象内容
            })
        },
        fileReview(file) {
            if (file.fileType == 'link') {
                window.open(file.extraData)
                return
            }
            if (!this.isdisabled(file)) return
            // console.log(file)
            // switch (fileType) {
            //     case 'png':
            //     case 'gif':
            //     case 'jpg':
            //         fileType = 'pic'
            //         break;
            //     case 'mp4':
            //     case 'flv':
            //         fileType = 'video'
            //         break;
            // }
            const fileType = this.getFileType(file.filePath, false)
            if (fileType === 'doc') {
                this.handleDocPreview(file)
            }
            this.reviewFile = { ...file, filePath: window.decodeURIComponent(file.filePath), fileType: fileType }
            console.info(this.reviewFile)
            this.filePreviewVisible = true;
        },
        handleDocPreview(el) {
            const that = this
            const filepath = el.filePath;
            const filename = decodeURIComponent(common.getFileNameByPath(filepath));
            const fileType = common.getFileTypeByPath(filepath);
            const key = Date.now().toString();
            const documentType = common.getDocumentType(fileType);
            const url = filepath.includes("http") ? filepath : location.origin + filepath;
            const config = {
                document: {
                    fileType,
                    key,
                    title: filename,
                    url
                },
                documentType,
                height: "100%",
                type: "desktop",//desktop mobile embedded
                width: "100%",
                lang: "zh-cn",
                editorConfig: {
                    // "coEditing": {
                    //     "mode": "fast",
                    //     "change": true
                    // },
                    lang: "zh-cn",
                    region: "zh-CN",
                    location: "cn",
                    mode: that.getIfPc() ? "view" : 'mobile',//view edit
                    user: {
                        // "group": "Group1",
                        id: this.loginUserInfo ? this.loginUserInfo.user_code : 'youke',
                        name: this.loginUserInfo ? this.loginUserInfo.nick_name : '游客'
                    },
                    // "plugins": {},
                    customization: {
                        help: false,
                        hideNotes: true,
                        comments: true,
                        chat: false,
                        integrationMode: "embed",
                        logo: {
                            image: "/documentserver/web-apps/apps/common/main/resources/img/header/header-logo_s.png",
                            imageDark: "/documentserver/web-apps/apps/common/main/resources/img/header/dark-logo_s.png",
                            url: "http://www.sobey.com"
                        },
                        uiTheme: "theme-classic-light",//theme-light, theme-classic-light, theme-dark, theme-contrast-dark default-dark, default-light default:theme-classic-light
                    }
                },
            }
            config.token = common.jwtSign(config, "tUVvbKk2mX4T40MBRrtj");
            this.$nextTick(() => {
                setTimeout(() => {
                    window.loadScript('/documentserver/web-apps/apps/api/documents/api.js').then(() => {
                        new DocsAPI.DocEditor("document-container", config);
                    })
                }, 2000)
            })
        },
        // 发表评论
        async publishComment(e) {
            if (this.commentData.content === '' || this.commentData.content == null) return
            API.reqSensitiveWord(this.commentData.content, '评论', () => API.reqPublishEvaluation({
                courseId: baseInfo.contentId,
                content: this.commentData.content,
                star: this.commentData.star
            })).then(res => {
                if (res.message === config.successMessage) {
                    this.$message.success('发布评论成功');
                    this.commentData.content = ""
                } else {
                    this.$message.error(res.message)
                }
                if (this.getIfPc()) {
                    this.$refs.comment_list.getCommentList()
                } else {
                    this.$refs.comment_list_mobile.getCommentList()
                }
            })
        },
        courseTabChange(e) {
            if (e.name == 4) {
                //切换评论
                if (this.getIfPc()) {
                    this.$refs.comment_list.getCommentList()
                } else {
                    this.$refs.comment_list_mobile.getCommentList()
                }
            }
        },
        pointHandle(e) {
            this.player.currentTime = e.inpoint || 0
            this.player.play()
        },
        //字幕按钮初始化
        initTrack(lans) {
            const that = this
            if (!lans || !this.sysModulesFormat.includes('micro_voice_show')) {
                //无语音分析，隐藏语音文本并且不初始化字幕按钮
                return this.voiceTextShow = false
            }
            // this.player.emit('multiTextTrack', lans)
            const timer = setInterval(() => {
                if(that.player && that.player.setMultiTextTrack){
                    let _lans = Object.keys(lans).map(srclang=>{
                        return {
                            lable: lans[srclang],
                            src: "/rman/v1/search/webvtt?contentId=" + this.player.videoId + "&voice=true&isSysAuth=true&lang=" + srclang,
                            srclang,
                            default: this.sysModulesFormat.includes('course_video_show_texttrack_default')
                        }
                    })
                    that.player.setMultiTextTrack(_lans)
                    clearInterval(timer)
                }
            }, 300)
            setTimeout(() => {
                clearInterval(timer)
            }, 10 * 1000);
        },
        // 添加选中语音笔记
        addSelectVoiceNote({ voiceInfo }) {
            this.userTab = '3'
            this.$refs.course_note_panel.insertNote({
                type: 'text',
                pointIn: voiceInfo.pointIn,
                pointOut: voiceInfo.pointOut,
                note: voiceInfo.note,
                remark: '',
                resourceId: this.currentPlayVideo.contentId,
                text: voiceInfo.note,
            })
            // const newNote = {
            //     courseId: baseInfo.contentId,
            //     courseName: baseInfo.name,
            //     noteType: 'micro',
            //     pointIn: voiceInfo.pointIn,
            //     pointOut: voiceInfo.pointOut,
            //     note: voiceInfo.note,
            //     remark: '',
            //     resourceId: this.currentPlayVideo.courseId,

            // };
            // API.reqCourseNoteAdd(newNote).then(res => {
            //     if (res.statusCode == 200) {
            //         this.userTab = '3'
            //         if (this.getIfPc()) {
            //             // this.$refs.course_note_panel.addNoteHandel()
            //             this.$refs.course_note_panel.getNoteList(res.data)
            //         } else {
            //             // this.$refs.course_note_panel_mobile.addNoteHandel()
            //             this.$refs.course_note_panel_mobile.getNoteList(res.data)
            //         }
            //     } else {
            //         this.$message.error(res.message || '请求失败')
            //     }
            // })
        },
        renderFileIcon(fileName) {
            let type = 'file';
            type = this.getFileType(fileName);
            const fileArr = Object.keys(FileMap);
            return (fileArr.includes(type) && type !== 'pdf' && type !== 'word' && type !== 'ppt') ? `${type}` : 'file';
        },
        getFileType(fileName, isIcon = true) {
            const arr = fileName.split('?')[0] ? fileName.split('?')[0].split('.') : [];
            const format = arr[arr.length - 1];
            let type = 'file';
            if (format) {
                const doc = ["doc", "docm", "docx", "docxf", "dot", "dotm", "dotx", "epub", "fodt", "fb2", "htm", "html", "mht", "odt", "oform", "ott", "oxps", "pdf", "rtf", "txt", "djvu", "xml", "xps", "csv", "fods", "ods", "ots", "xls", "xlsb", "xlsm", "xlsx", "xlt", "xltm", "xltx", "fodp", "odp", "otp", "pot", "potm", "potx", "pps", "ppsm", "ppsx", "ppt", "pptm", "pptx"]
                if (doc.includes(format) && !isIcon) return "doc"
                type =
                    Object.keys(FileMap).find((type) => FileMap[type].includes(format.toLowerCase())) ||
                    'file';
            }
            return type;
        },
        noteSeek(info) {
            const { currentTime } = info
            if (!this.player) {
                //未初始化完先把时间缓存起来
                this.noteVideoTime = currentTime
            } else {
                this.player.currentTime = currentTime
                this.player.play()
            }
        },
        handleAddNote() {
            if (!this.loginUserInfo || !this.loginUserInfo.user_code) return this.$message.info('登录后可使用笔记功能')
            this.userTab = '3'
            this.userTabMoblie = '4'
            if (this.getIfPc()) {
                this.$refs.course_note_panel.addNoteHandel()
            } else {
                this.$refs.course_note_panel_mobile.addNoteHandel()
            }
        },
        //初始化浏览器窗口关闭事件监听
        initCloseEvent() {
            const that = this
            window.onbeforeunload = function (e) {
                that.onPlayerStateChange()
            }
        },
        //保存记忆播放数据、更新学习时长
        onPlayerStateChange() {
            //记录视频播放位置
            console.log('记录播放位置', this.player)
            if (!this.player || !this.hasLogin) return
            this.player.saveVideoHistory(this.videoHistoryParams)
            this.updateLearnTime()
        },
        getCoursePictureList(info) {
            // console.log('课件截图',info)
            API.reqCoursePictureList({ contentId: info.contentId, groupName: 'keyframe_', isScreenShot: true }).then(res => {
                if (res.success) {
                    this.coursePictureList = res.data
                    if (this.coursePictureList.length && !this.hasCourseOverview) {
                        this.initDefaultTab()
                    }
                } else {
                    this.coursePictureList = []
                }
            })
        },
        // 时长转换，百纳秒转时分秒
        durationTrans(a) {
            if (!a) return ''
            a = parseInt(a / 10000000)
            var b = ""
            var h = parseInt(a / 3600),
                m = parseInt(a % 3600 / 60),
                s = parseInt(a % 3600 % 60);
            if (h > 0) {
                h = h < 10 ? '0' + h : h
                b += h + ":"
            }
            m = m < 10 ? '0' + m : m
            s = s < 10 ? '0' + s : s
            b += m + ":" + s
            return b;
        },
        //获取微课部分信息
        initExtendInfo() {
            const that = this
            API.reqMicroExtendInfo({ courseId: baseInfo.contentId }).then(res => {
                console.log('originVideoText', res)
                if (res.status == 200) {
                    this.avgStar = res.data.avgStar

                }
            })
            this.getRecommendList({ courseId: this.courseId })
            this.getTeacherCourseNumbers(teacherCodes[0]) //获取教师信息课程数量
            this.getTeacherAvatar(teacherCodes[0])
            // if (!this.loginUserInfo && !this.unLoginShow) return
            //统计观看时长
            // API.reqUpdateLearnTime({
            //     courseType: 0,
            //     courseId: this.courseId,
            //     timeInterval: 0
            // }).then()
        },
        //数据采集
        courseUserGather() {
            if (!this.loginUserInfo || !this.loginUserInfo.user_code) return
            let params = {
                type: "edu.user_course",
                content: {
                    user_code: this.loginUserInfo.user_code,
                }
            }
            let teacher_codes = baseInfo.entityData.teacher
            if (teacher_codes.length) {
                params.content.teacher_codes = teacher_codes
            }
            let subject_code = baseInfo.entityData.subject.pop()
            if (subject_code) {
                params.content.subject_code = subject_code
            }
            let college_code = baseInfo.entityData.college.pop()
            if (subject_code) {
                params.content.college_code = college_code
            }
            API.reqCourseUserGather(params).then()
        },
        //获取右侧tab最高高度
        getRightTabMaxHeight() {
            const that = this
            setTimeout(() => {
                let h = 600
                if(document.querySelector('.video_box') && document.querySelector('.video_box').clientHeight){
                    h = document.querySelector('.video_box').clientHeight
                }else if(document.querySelector('.preview_box') && document.querySelector('.preview_box').clientHeight){
                    h = document.querySelector('.preview_box').clientHeight
                }
                //有classname为preview_box就取这个dom 
                if (that.bannerPlateType == 6) {
                    that.rightTabMaxHeight = h - 108 + 'px'
                } else {
                    that.rightTabMaxHeight = h - 20 + 'px'
                }
            }, 1000);
        },
        //播放器版权水印
        initPlayerWatermark() {
            API.reqPlayerWatermark().then(res => {
                if (res.errorCode == 'success' && res.extendMessage && res.extendMessage.length) {
                    const data = res.extendMessage[0]
                    const { watermarkModule = [], watermarkLocation, watermarkPictureUrl } = data
                    if (watermarkModule.includes(2)) {
                        this.watermarkPictureUrl = watermarkPictureUrl
                        this.watermarkLocation = watermarkLocation
                    }
                }
            })
        },
        getIfHasOverview(flag){
            this.hasCourseOverview = flag
            this.initDefaultTab()
        },
        addHistory() {
            API.getPreviewHistory([{id: this.courseId, type: 2, name: this.courseInfo.name}])
        },
        handleResourceQa(){
            this.userTab = 'resource_qa'
            const base64 = window.getVideoSnapshot(this.player.video)
            this.$refs.resource_qa_panel?.screenShotQa?.({
                name: baseInfo.name + '_' + Date.now(),
                base64
            })
        }
    }
})
